<template>
  <UApp :locale="es" :toaster="null">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
import { es } from '@nuxt/ui/locale'
import '~/assets/css/main.css'
import '~~/zod-config'
import { useHeadConfigComposable } from '~~/modules/head/composables/useHeadConfigComposable'

useHeadConfigComposable()
</script>
